import { render, staticRenderFns } from "./PillSelector.vue?vue&type=template&id=3ca012a2"
import script from "./PillSelector.vue?vue&type=script&lang=js"
export * from "./PillSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports